import { type ReactElement } from 'react';
import { Redirect } from 'react-router-dom';

import { useAtomValue } from 'jotai';

import { useAuth } from '@/contexts/AuthProvider';

import { PRIVATE_ROUTES, LANDING_ROUTES } from '@/config/routes';

import { emailIsNotProvidedAtom } from '@/components/soundCloud/signUpAtoms';

export const PublicRoute = ({ children }: { children: ReactElement }) => {
  const { isAuthenticated } = useAuth();
  const emailIsNotProvided = useAtomValue(emailIsNotProvidedAtom);

  if (emailIsNotProvided) {
    return <Redirect to={LANDING_ROUTES.provideEmail} />;
  }

  return isAuthenticated ? <Redirect to={PRIVATE_ROUTES.home} /> : children;
};
